import { t } from '@/i18n/translator';

export const ReorderAssetsCommand = (
  reorderAssetsMutation: any,
  assetIds: Array<string>,
  albumId: string | Array<string> | undefined,
) => {
  let position: number;
  let oldPosition: number;

  const apply = (): void => {
    if (albumId !== undefined) {
      void reorderAssetsMutation({ albumId: String(albumId), assetIds, position, undoable: true });
    }
  };

  const update = (params: { position: number; oldPosition: number }) => {
    position = params.position;
    oldPosition = params.oldPosition;
  };

  const undo = (): void => {
    if (albumId !== undefined) {
      void reorderAssetsMutation({ albumId: String(albumId), assetIds, position: oldPosition });
    }
  };

  const redo = (): void => {
    void apply();
  };

  return {
    apply,
    update,
    undo,
    redo,
    message: t('commands.reorderAssets', { count: assetIds.length }),
  };
};
